import { ArrowLeft, Heart, Share2, Crown, ChevronRight } from 'lucide-react'

interface RoomDetailsHeaderProps {
  roomId: string
  isFavorited: boolean
  onBack: () => void
  onFavorite: () => void
  onShare: () => void
}

const RoomDetailsHeader = ({ roomId, isFavorited, onBack, onFavorite, onShare }: RoomDetailsHeaderProps) => {
  return (
    <div className="room-details-header text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-primary-600 via-primary-700 to-primary-800"></div>
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="relative z-10">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14 sm:h-16">
            <div className="flex items-center gap-2 sm:gap-4 min-w-0">
              <button 
                onClick={onBack}
                className="p-1.5 sm:p-2 hover:bg-white/20 rounded-lg transition-all duration-300 hover:scale-110 flex-shrink-0"
              >
                <ArrowLeft className="h-5 w-5" />
              </button>
              <div className="flex items-center gap-2 sm:gap-3 min-w-0">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Crown className="h-5 w-5 sm:h-6 sm:w-6" />
                </div>
                <div className="min-w-0">
                  <h1 className="text-lg sm:text-2xl font-bold truncate">Room {roomId}</h1>
                  <p className="text-xs sm:text-sm text-white/80 hidden sm:block">Deluxe Experience</p>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2 sm:gap-4 flex-shrink-0">
              <div className="hidden md:flex items-center gap-2 text-sm">
                <span className="text-white/80">Home</span>
                <ChevronRight className="h-4 w-4 text-white/60" />
                <span>Room Details</span>
              </div>
              <div className="flex items-center gap-1.5 sm:gap-2">
                <button 
                  onClick={onFavorite}
                  className={`p-1.5 sm:p-2 rounded-lg transition-all duration-300 ${
                    isFavorited 
                      ? 'bg-red-500 text-white' 
                      : 'bg-white/20 text-white hover:bg-white/30'
                  }`}
                >
                  <Heart className={`h-4 w-4 sm:h-5 sm:w-5 ${isFavorited ? 'fill-current' : ''}`} />
                </button>
                <button 
                  onClick={onShare}
                  className="p-1.5 sm:p-2 bg-white/20 text-white rounded-lg hover:bg-white/30 transition-all duration-300"
                >
                  <Share2 className="h-4 w-4 sm:h-5 sm:w-5" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RoomDetailsHeader

